import { BulletBotPlusInfo } from "../types/Contract/HelperBot/BulletBotPlusInfo";
import { HelperBotInfo } from "../types/Contract/HelperBot/HelperBotInfo";
import { HelperSmuggleBotInfo } from "../types/Contract/HelperBot/HelperSmuggleBotInfo";

export const parseNewCarNickInfo = (data: any) => {
  return {
    criminal: data.criminal,
    crimeType: parseInt(data.crimeType),
    isSuccess: Boolean(data.isSuccess),
    isJailed: Boolean(data.isJailed),
    cashAmount: parseFloat(data.cashAmount),
    xpPoint: parseInt(data.xpPoint),
    nextNickTime: Number(data.nextNickTime),
    timestamp: Number(data.timestamp),
    block: Number(data.block),
    inventoryItemId: Number(data.inventoryItemId),
    cityId: Number(data.cityId),
    carType: Number(data.carType),
    damagePercent: Number(data.damagePercent),
    successNonce: Number(data.successNonce),
  };
};

export const parseNewCrimeInfo = (data: any) => {
  return {
    criminal: data.criminal,
    crimeType: parseInt(data.crimeType),
    isSuccess: Boolean(data.isSuccess),
    isJailed: Boolean(data.isJailed),
    cashAmount: parseFloat(data.cashAmount),
    xpPoint: parseInt(data.xpPoint),
    nextCrimeTime: data.nextCrimeTime,
    timestamp: data.timestamp,
  };
};

export const parseBoozeBuyInfo = (data: any) => {
  return {
    buyer: data.buyer,
    isSuccess: Boolean(data.isSuccess),
    isJailed: Boolean(data.isJailed),
    totalUserBoozeCount: Number(data.totalUserBoozeCount),
    cashAmount: parseFloat(data.cashAmount),
    xpPoint: Number(data.xpPoint),
    nextBoozeTime: Number(data.nextBoozeTime),
    timestamp: Number(data.timestamp),
  };
};

export const parseBoozeSellInfo = (data: any) => {
  return {
    seller: data.seller,
    isSuccess: Boolean(data.isSuccess),
    isJailed: Boolean(data.isJailed),
    totalUserBoozeCount: Number(data.totalUserBoozeCount),
    cashAmount: parseFloat(data.cashAmount),
    owner: data.owner,
    ownerProfit: parseFloat(data.ownerProfit),
    xpPoint: Number(data.xpPoint),
    nextBoozeTime: Number(data.nextBoozeTime),
    timestamp: Number(data.timestamp),
  };
};

export const parseNarcsBuyInfo = (data: any) => {
  return {
    buyer: data.buyer,
    isSuccess: Boolean(data.isSuccess),
    isJailed: Boolean(data.isJailed),
    totalUserNarcsCount: Number(data.totalUserNarcsCount),
    cashAmount: parseFloat(data.cashAmount),
    xpPoint: Number(data.xpPoint),
    nextNarcsTime: Number(data.nextNarcsTime),
    timestamp: Number(data.timestamp),
  };
};

export const parseNarcsSellInfo = (data: any) => {
  return {
    seller: data.seller,
    isSuccess: Boolean(data.isSuccess),
    isJailed: Boolean(data.isJailed),
    totalUserNarcsCount: Number(data.totalUserNarcsCount),
    cashAmount: parseFloat(data.cashAmount),
    owner: data.owner,
    ownerProfit: parseFloat(data.ownerProfit),
    xpPoint: Number(data.xpPoint),
    nextNarcsTime: Number(data.nextNarcsTime),
    timestamp: Number(data.timestamp),
  };
};

export const parseNewKillSkillInfo = (data: any) => {
  return {
    trainer: data.trainer,
    trainType: Number(data.trainType),
    isSuccess: Boolean(data.isSuccess),
    trainCost: parseFloat(data.trainCost),
    xpPoint: Number(data.xpPoint),
    nextTrainTime: Number(data.nextTrainTime),
    timestamp: Number(data.timestamp),
  };
};

export const parseHelperBotInfo = (data: any) => {
  return {
    successRate: Number(data.successRate),
    startTimestamp: Number(data.startTimestamp),
    endTimestamp: Number(data.endTimestamp),
    attemptCount: Number(data.attemptCount),
    isRunning: Boolean(data.isRunning),
  } as HelperBotInfo;
};

export const parseBulletBotPlusInfo = (data: any) => {
  return {
    amountModifiedPercent: Number(data.amountModifiedPercent),
    priceModifiedPercent: Number(data.priceModifiedPercent),
  } as BulletBotPlusInfo;
};

export const parseHelperSmuggleBotInfo = (data: any) => {
  return {
    successRate: Number(data.successRate),
    startTimestamp: Number(data.startTimestamp),
    endTimestamp: Number(data.endTimestamp),
    attemptCount: Number(data.attemptCount),
    amountPerPurchase: Number(data.amountPerPurchase),
    isRunning: Boolean(data.isRunning),
  } as HelperSmuggleBotInfo;
};

export const parseHelperBotEndedInfo = (data: any) => {
  return {
    user: data.user,
    botType: Number(data.botType),
    xpEarned: Number(data.xpEarned),
    cashEarned: parseFloat(data.cashEarned),
    carCount: Number(data.carCount),
    cashSpent: Number(data.cashSpent),
    bulletEarned: Number(data.bulletEarned),
    ownerProfit: parseFloat(data.ownerProfit),
    timestamp: Number(data.timestamp),
  };
};

export const parseBulletBuyInfo = (data: any) => {
  return {
    buyer: data.buyer,
    isSuccess: Boolean(data.isSuccess),
    cashAmount: parseFloat(data.cashAmount),
    bulletAmount: Number(data.bulletAmount),
    nextBuyTime: Number(data.nextBuyTime),
    timestamp: Number(data.timestamp),
  };
};
